export default class importOvatBillModalContentCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, $uibModal) {
        $scope.modaldata = items1
        console.log($scope.modaldata)
        $scope.splitResultCount = 0
        // 导出操作
        // 导入
        // 错误信息页脚分页参数
        $scope.pageModalImportOpt = {
            totalItems: $scope.modaldata.params.data.total, // 组件初始化设置总页数
            currentPage: ++$scope.modaldata.params.data.prePage, // 设置显示第一页
            maxSize: $scope.modaldata.params.data.pageSize, // 每一叶显示记录数
        }
        // 页码操作
        $scope.pageModalImportChanged = function () {
            const _req = {
                pageNum: $scope.pageModalImportOpt.currentPage,
                pageSize: $scope.pageModalImportOpt.maxSize,
                param: $scope.modaldata.params.batchNo,
            }
            httpRequest.post_getPageDlBatchInfoList(_req).then((res) => {
                $scope.modaldata.params.data = res.data.value
                $scope.pageModalImportOpt = {
                    totalItems: $scope.modaldata.params.data.total, // 组件初始化设置总页数
                    currentPage: ++$scope.modaldata.params.data.prePage, // 设置显示第一页
                    maxSize: $scope.modaldata.params.data.pageSize, // 每一叶显示记录数
                }
            })
        }
        // 查看拆分结果
        const _req1 = {
            pageNum: 1,
            pageSize: 10,
            param: $scope.modaldata.params.batchNo,
        }
        httpRequest.post_getBillSplitCountList(_req1).then((res) => {
            $scope.splitResultCount = res.data.value.total
        })
        $scope.showSplitResult = function showSplitResult() {
            httpRequest.post_getBillSplitCountList(_req1).then((res) => {
                const splitResult = res.data.value
                const modalData = {
                    batchNo: $scope.modaldata.params.batchNo,
                    splitResult,
                    idToken: $scope.modaldata.idToken,
                    splitResultCount: $scope.splitResultCount,
                }
                // 弹窗
                $uibModal.open({
                    templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/splitResult.html',
                    controller: 'splitResultCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal-importexcel mod-modal',
                    bindToController: true,
                    windowClass: ' split-bill-result-modal',
                    resolve: {
                        items1() {
                            return modalData
                        },
                    },
                })
            })
        }
        // 关闭
        $scope.cancelModalImport = function () {
            //$scope.modaldata.queryOvatBillList()
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.downBatchInfo = function (v) {
            // 返回数据
            const _res = {
                params: {},
            }
            window.open(`${host.etcloudOvat}dlTaskService/downBatchInfoDetail?batchNo=${v}&accessToken=${$scope.modaldata.idToken}`)
            $uibModalInstance.close(_res)
        }
    }
}
importOvatBillModalContentCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', '$uibModal']


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/importOvatBillModalContentCtrl.js